//console.log('hello from stashlogix_1.js')
$(document).ready(function () {
  let count = 0
  let speedFactor = 0.8
  function stashlogix_typer(delay) {
    //console.log('stashlogix_typer called')
    if (count < 3) {
      let text = '0_____a shoebox?__________ ^really?__________9~stash`logically!_______<<<<<<x|'
      let textArray = text.split('')
      let addFade = false
      textArray.forEach(char => {
        //console.log('char', char)
        char === '~' ? (char = '<br>') : null

        char === '^' ? (char = '&nbsp;') : null

        char === '_' ? (char = '') : null

        char === '`' ? (char = '<span class="stashlogix_remove"> </span>') : null

        if (char === '0') {
          addFade = true
          char = ''
        }
        if (char === '9') {
          addFade = false
          char = ''
        }
        if (addFade) {
          char = `<span class="stashlogix_fade_target">${char}</span>`
        }

        if (char === '<') {
          delay += Math.floor(Math.random() * 80) + 300
        } else if (char === '|') {
          delay += Math.floor(Math.random() * 80) + 500
        } else {
          delay += Math.floor(Math.random() * 80) + 100
        }

        setTimeout(function () {
          if (char === '<' && $('.stashlogix_type_1').html() !== undefined) {
            let copy = $('.stashlogix_type_1').html()
            //console.log('test1', copy)
            let newCopy = copy.substring(0, copy.length - 1)
            $('.stashlogix_type_1').html(newCopy)
          } else if (char === '|') {
            $('.stashlogix_remove').html('')
            $('.stashlogix_fade_target').addClass('stashlogix_fade')
            setTimeout(function () {
              $('.stashlogix_fade_target').css('display', 'none')
              $('.stashlogix_type_1').addClass('stashlogix_stretch')
              setTimeout(function () {
                $('.stashlogix_type_1').css('font-weight', 'bold')
                $('.stashlogix_type_1').css('color', 'white')
                $('.stashlogix_type_1').css('text-transform', 'uppercase')
                setTimeout(function () {
                  //$('.stashlogix-type-1').addClass('fade2')
                  setTimeout(function () {
                    $('.stashlogix_type_1').html('')
                    $('.stashlogix_type_1').removeClass('stashlogix_stretch')
                    $('.stashlogix_type_1').removeClass('stashlogix_fade')
                    //$('.stashlogix_type_1').removeClass('fade2')
                    $('.stashlogix_type_1').css('font-weight', 'normal')
                    $('.stashlogix_type_1').css('color', 'lime')
                    $('.stashlogix_type_1').css('text-transform', 'inherit')
                    stashlogix_typer(0)
                  }, 2000*speedFactor)
                }, 2000*speedFactor)
              }, 1500*speedFactor)
            }, 2100*speedFactor)
          } else {
            $('.stashlogix_type_1').append(char)
            //console.log('appending', char)
          }
        }, delay*speedFactor)
      })
    }
  }

  stashlogix_typer(2000*speedFactor)
})